module.exports = __webpack_public_path__ + "static/media/gb-hero-logo.ea2daf7f.png";